import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stage-tirocini',
  templateUrl: './stage-tirocini.component.html',
  styleUrls: ['./stage-tirocini.component.css']
})
export class StageTirociniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
